import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import type { Policy } from '@/data/subsidy/policies/interfaces';
import type { Course } from '@/models/catalog/course';

interface SubscriptionAvailableForRefundResponse {
  data: { items: Course[] };
}

export const useAvailableSubscriptions = (policy: Policy) => {
  const refundEligibilityInDays =
    policy?.configuration?.refund_eligibility_in_days ?? 0;

  const searchParams = new URLSearchParams();
  searchParams.set(
    'months_to_subtract',
    Math.floor(refundEligibilityInDays / 30).toString()
  );
  const response = useQuery<SubscriptionAvailableForRefundResponse>({
    queryKey: ['last-policy', refundEligibilityInDays],
    queryFn: async () =>
      await edupassClient.get(
        `/subsidies/subscription_available_for_refund?${searchParams.toString()}`
      ),
    enabled: !!policy,
  });

  const subscriptions = response.data?.data?.items;

  return { subscriptions, ...response };
};
